// Palette
import { red } from '@mui/material/colors';

export default {
  filledError: {
    backgroundColor: red[900],
    fontSize: '14px',
  }
};
